import React, { useEffect, useState } from 'react';
import { useData } from '../../hooks/useData'; // not used for currentUserData, but kept for potential other context values
import { usersManagementServices } from '../../APIServices/usersManagementServices'; // 👈 added to fetch user details
import { userServices } from '../../APIServices/userServices'; // keep existing
import Pagination from '../../hooks/Pagination';
import Moment from 'react-moment';

function FailedLoginHistory() {
  // ❌ Remove the broken context destructuring
  // const { currentUserData } = useData();

  // ✅ Local state for user data and loading
  const [userId, setUserId] = useState(null);
  const [userLoading, setUserLoading] = useState(true);
  
  const [logList, setLogList] = useState([]);
  const [logCount, setLogCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const [searchData, setSearchData] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(logCount / itemsPerPage);

  // ✅ Fetch current user's ID on mount
  useEffect(() => {
    const loadUser = async () => {
      const data = await usersManagementServices.getCurrentUserDetails();
      setUserId(data?.data?.userId || null);
      setUserLoading(false);
    };
    loadUser();
  }, []);

  const getUserFailedLoginData = async () => {
    if (!userId) return; // wait for userId to be available
    setLoading(true);
    try {
      const data = await userServices.getUserFailedLoginData(
        userId,
        "all",
        searchData,
        pageNumber,
        itemsPerPage
      );
      setLogList(data?.data || []);
      setLogCount(data?.count || 0);
    } catch (error) {
      console.error('Failed to fetch login logs:', error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch logs when userId, pageNumber, or itemsPerPage change
  useEffect(() => {
    if (userId) {
      getUserFailedLoginData();
    }
  }, [userId, pageNumber, itemsPerPage]);

  // Optionally, if you want search to trigger a fetch, you can add searchData dependency with a debounce, but as is it's not included; you might want to include it.

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-eyebrow">Governance</div>
          <h1 className="page-title">Failed Login History</h1>
          <p className="page-sub">
            View and monitor all failed login attempts across the platform. Track unsuccessful sign-in activities to identify unauthorized access attempts, investigate security incidents, and improve account protection.
          </p>
        </div>
      </div>

      <div className="flex between center mb-3">
        <div className="section-label">
          Failed Login History <span className="count">{logCount}</span>
        </div>
      </div>
      <div className="card">
        {userLoading ? (
          <div style={{ padding: 40, textAlign: 'center' }}>
            <div className="buttonLoader" />
            <div style={{ marginTop: 12 }}>Loading user data...</div>
          </div>
        ) : loading ? (
          <div style={{ padding: 40, textAlign: 'center' }}>
            <div className="buttonLoader" />
            <div style={{ marginTop: 12 }}>Loading logs...</div>
          </div>
        ) : logCount === 0 ? (
          <div style={{ padding: 24, textAlign: 'center', color: 'var(--ink-3)' }}>
            <i className="ti ti-users" style={{ fontSize: 24, display: 'block', marginBottom: 8 }} />
            No Logs.
          </div>
        ) : (
          <>
            <table className="tbl">
              <thead>
                <tr>
                  <th>IP Address</th>
                  <th>Location</th>
                  <th>TimeZone</th>
                  <th>UserId</th>
                  <th>Email</th>
                  <th>Password</th>
                  <th>Try Date | Time</th>
                </tr>
              </thead>
              <tbody>
                {logList.map((item) => (
                  <tr key={item.id}>
                    <td>{item.ipAddress}</td>
                    <td>{item.location}</td>
                    <td>{item.timeZone}</td>
                    <td>{item.userName}</td>
                    <td>{item.email}</td>
                    <td>{item.password}</td>
                    <td>
                      <Moment format="DD MMM YYYY | HH:mm" withTitle>
                        {item.createdAt}
                      </Moment>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <Pagination
              itemsPerPage={itemsPerPage}
              setItemsPerPage={setItemsPerPage}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              totalPage={totalPage}
              totalItems={logCount}
            />
          </>
        )}
      </div>
    </div>
  );
}

export default FailedLoginHistory;